<div class="r180-resumen">
  <div class="r180-resumen__item">
    <span class="r180-resumen__label">Perceptores</span>
    <strong>{{ totalPerceptores | number:'1.0-0' }}</strong>
  </div>
  <div class="r180-resumen__item">
    <span class="r180-resumen__label">Base</span>
    <strong>{{ totalBase | number:'1.2-2' }} €</strong>
  </div>
  <div class="r180-resumen__item">
    <span class="r180-resumen__label">Retenciones e ingresos a cuenta</span>
    <strong>{{ totalRetenciones | number:'1.2-2' }} €</strong>
  </div>
</div>

<ng-template #origenTpl let-valor let-row="row">
  <span class="r180-origen" [class.r180-origen--manual]="valor === 'MANUAL'">
    <mat-icon>{{ valor === 'MANUAL' ? 'edit' : 'receipt' }}</mat-icon>
    {{ valor === 'MANUAL' ? 'Manual' : 'Contabilidad' }}
  </span>
</ng-template>

<ng-template #quickFilter>
  <div class="quick-filter r180-filtros">
    <app-search-filter [value]="quickSearch" placeholder="Buscar NIF o nombre..."
      (searchChange)="onSearchChange($event)"></app-search-filter>
  </div>
</ng-template>

<div class="cf-table-card">
  <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
</div>
